module.exports = __webpack_public_path__ + "static/media/landing-mngr.41b4371a.svg";